export default __webpack_public_path__ + "static/media/q2_step5.fd8c57bd.png";